import PortfolioList from "./portfolioPage/portfolioList";
import { useOutletContext } from "react-router";

import ModernBanner from "../shopping/component/themes/modern/banner";
import CuteBanner from "../shopping/component/themes/cute/banner";
import SimpleBanner from "../shopping/component/themes/simple/banner";
import ChicBanner from "../shopping/component/themes/chic/banner";
// import DefaultBanner from "../shopping/component/themes/default/banner";

import { Container } from "../common/styled";

const banners = {
  0: ModernBanner,
  1: ChicBanner,
  2: ModernBanner,
  3: CuteBanner,
  4: SimpleBanner,
};

export default function PortfolioPage() {
  const { theme } = useOutletContext();

  const getBannerInfo = (theme) => {
    if (theme === "sm") {
      return {
        page: `게시판`,
        message: `고객님을 위한 정책과\n더 나은 서비스를 제공합니다.`,
      };
    }
    return { imgage: "port.png", text: "portfolio" };
  };

  const renderComponent = () => {
    const Banner = banners[theme];

    return (
      <>
        {Banner && <Banner info={getBannerInfo(theme)} />}
        <PortfolioList />
      </>
    );
  };

  return <Container className={`theme-${theme}`}>{renderComponent()}</Container>;
}
